/**
 * Centralized notifications when an order action is blocked (proactive UI).
 * Picks the right message and toast type (error vs warning) in one place.
 */
import { notifyError, notifyWarning } from '../../../utils/utils';
import {
  ERROR_MESSAGES,
  getOrdersCannotBeChangedMessage,
  WARNING_MESSAGES,
} from './deal-series.constants';

export enum OrderBlockReason {
  ORDER_IN_TRANSIT = 'ORDER_IN_TRANSIT',
  ORDER_SUBMIT_FAILED = 'ORDER_SUBMIT_FAILED',
  ORDER_CANCEL_FAILED = 'ORDER_CANCEL_FAILED',
  ORDER_RECONFIRMED = 'ORDER_RECONFIRMED',
  ORDERS_DEAL_STATUS = 'ORDERS_DEAL_STATUS',
  MATURITY_NOT_IMPACTED_BY_PRICE_CHANGE = 'MATURITY_NOT_IMPACTED_BY_PRICE_CHANGE',
  CLEAR_ALL_REPRICE_NO_RESET = 'CLEAR_ALL_REPRICE_NO_RESET',
}

export interface OrderBlockContext {
  dealStatus?: string | null;
}

/** Show the appropriate toast (error or warning) for a given order block reason. */
export function notifyOrderBlocked(reason: OrderBlockReason, context?: OrderBlockContext): void {
  switch (reason) {
    case OrderBlockReason.ORDER_IN_TRANSIT:
      notifyError(ERROR_MESSAGES.ORDER_IN_TRANSIT);
      break;
    case OrderBlockReason.ORDER_SUBMIT_FAILED:
      notifyError(ERROR_MESSAGES.ORDER_SUBMIT_FAILED);
      break;
    case OrderBlockReason.ORDER_CANCEL_FAILED:
      notifyError(ERROR_MESSAGES.ORDER_CANCEL_FAILED);
      break;
    case OrderBlockReason.ORDER_RECONFIRMED:
      notifyWarning(WARNING_MESSAGES.ORDER_RECONFIRMED);
      break;
    case OrderBlockReason.ORDERS_DEAL_STATUS:
      notifyWarning(getOrdersCannotBeChangedMessage(context?.dealStatus));
      break;
    case OrderBlockReason.MATURITY_NOT_IMPACTED_BY_PRICE_CHANGE:
      notifyWarning(WARNING_MESSAGES.MATURITY_NOT_IMPACTED_BY_PRICE_CHANGE);
      break;
    case OrderBlockReason.CLEAR_ALL_REPRICE_NO_RESET:
      notifyWarning(WARNING_MESSAGES.CLEAR_ALL_REPRICE_NO_RESET);
      break;
  }
}
